import { queryOptions } from '@tanstack/react-query';

import { getCompetitorQuery, getCompetitorsQuery } from './shared';

export const getCompetitorQueryOptions = (id: string) => queryOptions(getCompetitorQuery(id));
export const getCompetitorsQueryOptions = () => queryOptions(getCompetitorsQuery());
